<template>
  <div class="preview-items">
    <div class="d-flex justify-content-between mb-4">
      <h2>{{ title }}</h2>
      <div class="d-flex align-items-center">
        <span class="mr-3">Filter</span>
        <CustomSelector
          v-model="selectValue"
          :options="filterOptions"
          class="preview-items__filter"
        />
      </div>
    </div>
    <b-overlay :show="filteredValuesLoading" rounded="sm" variant="transparent">
      <div class="preview-items__container">
        <p v-if="isNothingFound">
          {{ notFoundMessage }}
        </p>
        <PreviewImage
          v-for="item in items"
          v-else
          :key="item._id"
          class="mb-3"
          :item="item"
          :type="type"
          @click="$emit('click', item)"
        />
      </div>
    </b-overlay>
    <div v-if="items && items.length < total" class="text-center pb-5 pt-3">
      <Button
        variant="outline"
        size="sm"
        :loading="loading"
        @click="handleShowMoreClick"
      >
        View more
      </Button>
    </div>
  </div>
</template>

<script>
import CustomSelector from '../Elements/CustomSelector.vue';
import { DefaultFilterOptions, DefaultPageLimit } from '@/misc/constants';
import PreviewImage from '@/components/PreviewItems/PreviewImage';
import Button from '@/components/Elements/Button';

const type = {
  CREATORS: 'creators',
  PRODUCTS: 'products'
};

export default {
  name: 'PreviewItems',

  components: {
    Button,
    PreviewImage,
    CustomSelector
  },

  props: {
    title: {
      type: String,
      default: null
    },
    items: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    },
    paginatedBy: {
      type: [String, Number],
      default: DefaultPageLimit
    },
    type: {
      type: String,
      default: type.CREATORS
    },
    filterOptions: {
      type: Array,
      default: () => DefaultFilterOptions
    },
    filterValue: {
      type: String,
      required: true
    },
    filteredValuesLoading: {
      type: Boolean,
      default: false
    },
    isNothingFound: {
      type: Boolean,
      default: false
    },
    notFoundMessage: {
      type: String,
      default: 'Nothing found'
    }
  },

  computed: {
    selectValue: {
      get() {
        return this.filterValue;
      },
      set(value) {
        this.$emit('onFilterValueChange', value);
      }
    }
  },

  methods: {
    handleShowMoreClick() {
      if (this.loading) return;

      this.$emit('onViewMoreClick');
    }
  }
};
</script>

<style lang="scss" scoped>
$defaultWidth: 170px;

.preview-items {
  &__container {
    display: grid;
    grid-template-columns: repeat(2, $defaultWidth);
    justify-content: space-between;

    @media (max-width: 370px) {
      justify-content: center;
      grid-template-columns: $defaultWidth;
    }

    @media (min-width: $screen-width-md) {
      grid-template-columns: repeat(3, $defaultWidth);
    }

    @media (min-width: $screen-width-lg) {
      grid-template-columns: repeat(5, $defaultWidth);
    }

    @media (min-width: $screen-width-xl) {
      grid-template-columns: repeat(6, $defaultWidth);
    }
  }
}

.preview-items__filter::v-deep {
  .custom-selector {
    &__dropdown {
      .dropdown-toggle,
      .dropdown-toggle:active {
        width: 85px;
        height: 32px;
        padding: 5px 0 5px 15px;
        outline-style: none;
        background-color: $white-color !important;
        border: none;
        border-radius: 5px;

        .switch-icon {
          width: 12px;
          margin-right: 14px;
        }
      }

      ul {
        min-width: 85px;
        padding-top: 5px;
        padding-bottom: 5px;
        max-height: 167px;
        border-radius: 5px;
        border: 1px solid $white-color top bottom;
        overflow-y: auto;

        li {
          button {
            padding: 2px 15px;
          }
        }
      }
    }
  }
}
</style>
